// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"3ddd89a8","70":"79f4bf47","123":"6674744a","245":"024e3c68","272":"03417867","277":"e28c57ea","385":"cd0e2c40","453":"f77065d0","973":"97ebbe9c"}[chunkId] + ".chunk.js";
};